<div class="overlay" id="offerOverlay" *ngIf="(dailyOfferState.showOffer$ | async)">
  <div class="modal_m">
    <button class="modal__close" (click)="close()" aria-label="Close">✕</button>

    <div class="modal__top">
      <h1 class="headline">

        {{ "saveupto" | transloco
        }}
        <span class="amount">50%</span>
      </h1>
      <p class="sub"> {{ "saveuptotext" | transloco
        }}</p>
      <div class="timer" [class.alert-error-text]="(dailyOfferState.progress$ | async)! <= 80">
        {{ dailyOfferState.timer$ | async }}
      </div>

      <div class="progress-bar" [style.width.%]="dailyOfferState.progress$ | async"
        [class.danger]="(dailyOfferState.progress$ | async)! <= 80">
      </div>

    </div>

    <div class="modal__body">

      <!-- Item Card -->
      <div class="item" *ngFor="let element of brandOfferProducts">
        <div class="item__img">
          <img (click)="productDetails(element)" class="pointer" [src]="fixImage(element.image)" alt="product" />
        </div>

        <div class="item__content">
          <div class="item__titleRow">
            @if(isAr){
            <p class="product-name">
              {{element.name_ar}}
            </p>
            } @else {
            <p class="product-name">
              {{element.name_en}}
            </p>
            }

          </div>

          <div class="meta">

            <span class="new-price" [class.new-price-mobile]="isMobile">{{element.affiliationprice}} {{ "egpe" |
              transloco
              }}</span>
            @if(calcDis(element.pricea,element.pricec) != 0){
            <span class="old-price" [class.new-price-mobile]="isMobile">{{element.pricec}} {{ "egpe" | transloco
              }}</span>
            }

          </div>
          <button class="btn btn-add" [class.alert-error]="(dailyOfferState.progress$ | async)! <= 80"
            (click)="addToCart(element, $event)">
            {{ "addtocart" | transloco }}
          </button>

        </div>
      </div>

      <button type="button" class="btn see-more-btn" (click)="goToDailyOffers()">
        {{ "See More" | transloco }}
      </button>
    </div>
  </div>
</div>

<!-- Floating Offer Chip -->
<div class="offer-chip" *ngIf="!(dailyOfferState.showOffer$ | async) && showFloatingChip" (click)="reopen()">

  <img src="/assets/e-commerce/icons/77.webp" alt="item" class="chip-img">
  <span class="chip-timer">
    {{ dailyOfferState.timer$ | async }}
  </span>
</div>